import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Error() {
  return (
    <div>
      <Header />
      <div className="text-4xl mt-4 flex justify-center items-center h-screen">
        Error 404: Page Not Found
      </div>
      <Footer />
    </div>
  );
}
